import { Button, Card, Col, Form, Input, InputNumber, Row, Select } from "antd";
import React, { useState } from "react";

import { states as statess } from "../../../../../../utils/Util";
import { states as usStates } from "../../../../../../data/usStates";

import { TbCurrencyDollar } from "react-icons/tb";
import { yearss } from "../../data";

function EmployeeDetails({ data }) {
  const [checked, setChecked] = useState(false);
  return (
    <Row>
      <Col span={24}>
        <Card
          title="Employee Details"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <Row>
              <Col span={24}>
                <Form layout="vertical">
                  <Row gutter={[0, 8]}>
                    <Col span={24}>
                      <Row gutter={[16, 0]}>
                        <Col span={12}>
                          <Form.Item label="Employer Name">
                            <Input />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item label="Employer Phone Number">
                            <Input />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      <Row gutter={[16, 0]}>
                        <Col span={12}>
                          <Form.Item label="Employer Address">
                            <Input />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item label="Employer Address 2">
                            <Input />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      <Row gutter={[16, 0]}>
                        <Col span={6}>
                          <Form.Item>
                            <Input />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item>
                            <Select options={statess} />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item>
                            <Input />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item>
                            <Select options={usStates} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      <Row gutter={[16, 0]}>
                        <Col span={8}>
                          <Form.Item label="Monthly Salary">
                            <InputNumber
                              addonBefore={<TbCurrencyDollar size={16} />}
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item label="Position Held">
                            <Input />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item label="Years Worked">
                            <Select options={yearss} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      <Row gutter={[16, 0]}>
                        <Col span={12}>
                          <Form.Item label="Supervisor Name">
                            <Input />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item label="Supervisor Title">
                            <Input />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Supervisor Email Address">
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Col>
              <Col span={24}>
                <Row gutter={[8, 0]}>
                  <Col>
                    <Button type="primary">Save</Button>
                  </Col>
                  <Col>
                    <Button onClick={() => setChecked(false)}>Cancel</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          ) : (
            <Form
              colon={false}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 11 }}
              labelWrap={{ span: 8 }}
            >
              <Form.Item label="Employer Name">
                <p>--</p>
              </Form.Item>
              <Form.Item label="Address">
                <p>--</p>
              </Form.Item>
              <Form.Item label="Employer Phone Number">
                <p>--</p>
              </Form.Item>
              <Form.Item label="Monthly Salary">
                <p>--</p>
              </Form.Item>
              <Form.Item label="Position Held">
                <p>--</p>
              </Form.Item>
              <Form.Item label="Years Worked">
                <p>--</p>
              </Form.Item>
              <Form.Item label="Supervisor Name">
                <p>--</p>
              </Form.Item>
              <Form.Item label="Supervisor Title">
                <p>--</p>
              </Form.Item>
              <Form.Item label="Supervisor Email Address">
                <p>--</p>
              </Form.Item>
            </Form>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default EmployeeDetails;
